var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44961 4L2.84961 6.4V19.3928C2.84955 19.459 2.86594 19.5242 2.8973 19.5826C2.92865 19.6409 2.97401 19.6905 3.02928 19.727C3.08455 19.7635 3.14802 19.7857 3.21398 19.7916C3.27995 19.7975 3.34634 19.7869 3.40721 19.7608L8.44961 17.6L13.2496 20H14.0496V7.7976L17.2496 6.4264V12.7998H18.8496V4.6072C18.8497 4.54097 18.8333 4.47577 18.8019 4.41744C18.7706 4.35911 18.7252 4.30947 18.6699 4.273C18.6147 4.23652 18.5512 4.21433 18.4852 4.20843C18.4193 4.20254 18.3529 4.21311 18.292 4.2392L13.2496 6.4L8.44961 4ZM12.4496 7.7888V17.8112L9.24961 16.2112V6.1888L12.4496 7.7888ZM7.64961 6.084V16.2024L4.44961 17.5736V7.4552L7.64961 6.084Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8488 16.0001L18.8496 13.6001H17.2496L17.2488 16.0001H14.8496V17.6001H17.2488L17.2496 20.0001H18.8496L18.8488 17.6001H21.2496V16.0001H18.8488Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapNew);
export default __webpack_public_path__ + "static/media/icon-map-new.34e298b26a32a98edaf2b4544b136d40.svg";
export { ForwardRef as ReactComponent };